export { Property1StarBoldDoutone } from "./Property1StarBoldDoutone";
